import _ToolBar from '../ToolBar.jsx'
import MenuButtonMore from './MenuButtonMore.jsx'
import MenuButtonReviseProduct from './MenuButtonReviseProduct.jsx'
import MenuButtonPublishProduct from './MenuButtonPublishProduct.jsx'
import MenuButtonSaveProduct from './MenuButtonSaveProduct.jsx'

export default function ToolBar(props) {
    return (
        <_ToolBar {...props}>
            <div>
            </div>

            <div>
                <MenuButtonSaveProduct />
                <MenuButtonPublishProduct />
                <MenuButtonReviseProduct />
                <MenuButtonMore />
            </div>

            <div>
            </div>
        </_ToolBar>
    )
}
